import React, { useState } from 'react'
import { BtnV2, Link, l, Modal } from '@manychat/manyui'

import cm from './common.module.css'

export const MetaDeletionContactsNotification = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const handleOnClick = () => {
    setIsModalOpen(!isModalOpen)
  }

  return (
    <>
      <span className="m-r-xs">
        {l.translate('Data from Meta removed for some of your Contacts')}
      </span>

      <Link className={cm.link} onClick={handleOnClick}>
        {l.translate('Read more')}
      </Link>

      <Modal
        width={460}
        title={l.translate('Contact data from Meta removed')}
        open={isModalOpen}
        buttons={[
          <BtnV2 variant="primary" onClick={handleOnClick}>
            {l.translate('Got it!')}
          </BtnV2>,
        ]}
        onRequestClose={handleOnClick}
      >
        <p className="font-medium">
          {l.translate(
            'We removed their Meta IDs, profile data, and messages received through Meta.',
          )}
        </p>
        <p>
          {l.translate(
            "This can happen when a person or Meta itself starts a deletion on Meta's side. Those Contacts stay, with their tags and custom fields. No action needed.",
          )}
        </p>
      </Modal>
    </>
  )
}
